import { render } from "./CheckIcon.vue?vue&type=template&id=05da454c"
const script = {}
script.render = render

export default script